import $ from 'jquery'
var scrollSection = function () {

  var body = $('body');
  var inViewScroll;

  function inView() {
    //'Top of screen'
    var scroll_top = $(window).scrollTop();

    //'Optional: add in the window height (or half of it), so it becomes active when it hits this point'
    scroll_top += $(window).height() / 2;

    if ($('.body-wrapper__faq').length) {
      var sideNav = document.querySelector('.sidebar__nav');
      scroll_top == sideNav.offsetTop;
    }

    //'All the slides'
    var slides = $('.section');
    var last_slide = null;
    slides.each(function () {
      var slide = $(this);
      var slide_position = slide.offset().top;

      if (slide_position <= scroll_top) {
        last_slide = slide;

      }
    });

    if (last_slide != null) {
      last_slide.addClass('active');
      var inactive_slide = $('.section.active').not(last_slide);

      if (inactive_slide.length >= 0) {
        inactive_slide.removeClass('active');
      }

    }

    if ($('.section__horizontal-btm').hasClass('active')) {
      body.addClass('horizontal-btm');
    } else {
      body.removeClass('horizontal-btm');
    }

    if ($('.section__horizontal-top').hasClass('active')) {
      body.addClass('horizontal-top');
      $('.home-bg--btm').addClass('top');
    } else {
      body.removeClass('horizontal-top');
    }

    if ($('.section__vert-left').hasClass('active')) {
      body.addClass('vert-left');
    } else {
      body.removeClass('vert-left');
    }

    if ($('.section__vert-right').hasClass('active')) {
      body.addClass('vert-right');
    } else {
      body.removeClass('vert-right');
    }

    if ($('.section__horizontal-full').hasClass('active')) {
      body.addClass('horizontal-full');
    } else {
      body.removeClass('horizontal-full');
    }

    if ($('.faq__section').hasClass('active')) {
      var dataActive = $('.faq__section.active').attr('id');
      $('.sidebar__nav').find('a[data-anchor="' + dataActive + '"]').addClass('active').parent().siblings().find('a').removeClass('active');
    }

    if ($('.body-wrapper__about .section').hasClass('active') || $('.body-wrapper__home .section').hasClass('active')) {
      last_slide.addClass('fade-in');

      if (last_slide.hasClass('fade-in')) {
        return;
      }
    }

  }

  $(window).scroll(function () {
    inViewScroll = true;
  });

  setInterval(function () {
    if (inViewScroll) {
      inView();
      inViewScroll = false;
    }
  }, 250);


}

module.exports = scrollSection;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/scroll-section.js